export default __webpack_public_path__ + "static/media/prev-E1A-2.5941594b.png";